import { useCurrentRefinements, useClearRefinements } from 'react-instantsearch'
import { Button, Icon, Typography } from '@shc/ui'
// import SearchRefinementList from './SearchRefinementList'
import type { CurrentRefinementsConnectorParamsRefinement } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements'
import { hierarchicalDelimiter } from '@lib/utilities/search'
import SearchRefinementList from './search-refinement-list'

export interface SearchFacetMenuProps {
  facets: string[]
  facetConfigMap: Map<string, { title: string; operator: "or" | "and" | undefined; site?: string[] }>
  restrictedRegions: string[]
  refinementListLimit?: number
  disableSingleItemBehavior?: boolean
  site?: string;
}

export default function SearchFacetMenu({ facets, facetConfigMap, restrictedRegions, refinementListLimit = 6, disableSingleItemBehavior = true, site = 'public' }: Readonly<SearchFacetMenuProps>) {
  //get the facets that have been selected
  const { items, refine: refineFacets } = useCurrentRefinements()
  //clear all function
  const { refine } = useClearRefinements()

  const clearAllClick = () => {
    refine()
  }

  const clearRefinement = (
    refinement: CurrentRefinementsConnectorParamsRefinement,
    refinements: CurrentRefinementsConnectorParamsRefinement[]
  ) => {
    refineFacets(refinement)
    // loop over other refinements in this facet and deselect children in case of hierarchy
    refinements?.forEach((otherRefinement) => {
      if (
        typeof otherRefinement.value === 'string' &&
        otherRefinement.value.startsWith(refinement.value.toString())
      )
        refineFacets(otherRefinement)
    })
  }

  return (
    <div className='flex flex-col'>
      {/* current filters */}
      {Array.isArray(items) && items.length > 0 && (
        <>
          <div className='flex flex-row text-sm justify-between items-center'>
            <Typography className='text-base font-semibold'>Filtered by:</Typography>
            <Button
              variant='flat'
              width='auto'
              size='xs'
              className='p-0 underline text-gray-700 font-bold'
              onClick={() => clearAllClick()}>
              Clear all filters
            </Button>
          </div>

          <div className='py-5 border-b mb-5 gap-x-2 gap-y-1 flex flex-row flex-wrap'>
            <div className='-ml-2'>
            {items.map((item) =>
              item.refinements.map((refinement) => {
                const labelParts = refinement.label.split(hierarchicalDelimiter)
                return (
                  <Button
                    key={refinement.value}
                    className='!h-auto !text-left !inline !p-2 text-sm'
                    onClick={() => clearRefinement(refinement, item.refinements)}
                    width='auto'
                    color='transparent'>
                    {labelParts[labelParts.length - 1]}
                    <Icon icon='close' className='h-3 text-center pl-2' />
                  </Button>
                )
              })
            )}
            </div>
          </div>
        </>
      )}

      {/* selectable facets */}
      <div className='-mt-5'>
        {facets.map((facet) => {
          return (
            facetConfigMap.get(facet) && (!facetConfigMap.get(facet)?.site || facetConfigMap.get(facet)?.site?.includes(site)) && ( // only facets declared in constants.ts will be displayed
              <div key={facet} className='flex flex-col'>
                <SearchRefinementList
                  title={facetConfigMap.get(facet)?.title ?? facet}
                  attribute={facet}
                  showMore={true}
                  showMoreLimit={Infinity}
                  limit={refinementListLimit}
                  restrictedRegions={restrictedRegions}
                  operator={facetConfigMap.get(facet)?.operator}
                  disableSingleItemBehavior={disableSingleItemBehavior}
                />
              </div>
            )
          )}
        )}
      </div>
    </div>
  )
}
